import { api, authHeader } from "../configs/axiosConfigs";

const resolveBaseUrl = (source) =>
  source === "Management"
    ? "/SLN/Management/ContractorReferralWorkQueue"
    : "/SLN/SolarentOperator/ContractorReferralWorkQueue";

const ContractorReferralWorkQueueApi = {
  getFilterData: async (source = "SolarentOperator") => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/GetFilterData`,
      method: "GET",
      headers: authHeader(),
    });
    return response.data;
  },

  search: async (source = "SolarentOperator", searchParams = {}) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Search`,
      method: "POST",
      headers: authHeader(),
      data: searchParams,
    });
    return response.data;
  },

  assign: async (source = "SolarentOperator", requestId, assignedToUserId = null) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Assign`,
      method: "POST",
      headers: authHeader(),
      data: { requestId, assignedToUserId },
    });
    return response.data;
  },

  refer: async (source = "SolarentOperator", payload) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Refer`,
      method: "POST",
      headers: authHeader(),
      data: payload,
    });
    return response.data;
  },

  approve: async (source = "SolarentOperator", payload) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Approve`,
      method: "POST",
      headers: authHeader(),
      data: payload,
    });
    return response.data;
  },

  reject: async (source = "SolarentOperator", payload) => {
    const response = await api.request({
      url: `${resolveBaseUrl(source)}/Reject`,
      method: "POST",
      headers: authHeader(),
      data: payload,
    });
    return response.data;
  },
};

export default ContractorReferralWorkQueueApi;
